const path = "https://api.serikos1984.it/";

export default path;
